const { detect } = require('detect-browser');

export default {
    // name: 'detect_ie',
    data () {
        return {}
    },
    computed: {
        userAgent () {
            const browser = detect();
            if (process.env.VUE_APP_BUILD_ENV !== 'production') {
                if (browser) {
                    console.log(`browser.name => ${browser.name}`);
                    console.log(`browser.version => ${browser.version}`);
                    console.log(`browser.os => ${browser.os}`);
                }
            }
            return browser
        },
        isIE () {
            return ['trident', 'msie', 'microsoft internet Explorer', 'netscape'].includes(this.userAgent.name.toLowerCase()) || !['chrome', 'firefox', 'edge', 'safari', 'edge-chromium'].includes(this.userAgent.name.toLowerCase())
        }
    }
}